<template>
  <div>
<!--  <el-tab-pane label="车辆列表" name="carList">-->
<!--    <el-row v-show="showFilters">-->
<!--      &lt;!&ndash;查询条件&ndash;&gt;-->
      <el-form :model="carSearchForm" ref="carSearchForm" size="mini" :inline="true" :rules="searchFormRules">
        <el-col :span="3">
          <el-form-item prop="license">
            <el-input placeholder="车牌号" v-model="carSearchForm.license" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item prop="phone">
            <el-input placeholder="手机号" v-model="carSearchForm.phone" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item prop="brandName">
            <el-input placeholder="型号" v-model="carSearchForm.brandName" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1.5">
          <el-form-item>
            <el-button size="mini" type="primary" @click="resetSearchForm">清空</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="1.5">
          <el-form-item>
            <el-button size="mini" type="primary"class="el_search" icon="el-icon-search" @click="search"
                       :loading="getCarsLoading">查询
            </el-button>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="1.5">
          <el-form-item>
            <el-button size="mini" type="primary" @click="carAdd" icon="el-icon-plus" class="el-btn"
                       v-if="checkPermission(['bee:res:car:saveOrUpdateCar'])">
              新增车辆
            </el-button>
          </el-form-item>
        </el-col> -->
      </el-form>
<!--    </el-row>-->
    <!--列表数据-->
    <el-table :data="tableData" stripe style="width: 100%" ref="carTable" border
              @selection-change="handleSelectionChange" v-loading="carsLoading">
      <!--<af-table-column type="selection"></af-table-column>-->
      <af-table-column prop="license" label="车辆号码"></af-table-column>
      <af-table-column prop="brandName" label="型号"></af-table-column>
      <af-table-column prop="vin" label="VIN码"></af-table-column>
      <af-table-column prop="etc" label="ETC"></af-table-column>
      <af-table-column prop="phone" label="手机号"></af-table-column>
      <af-table-column prop="operatorId" label="所属运营商" :formatter="formatOperator"></af-table-column>
      <af-table-column prop="groupName" label="绑定集团"></af-table-column>
      <af-table-column prop="createTime" label="创建时间" :formatter="dateFormatter"></af-table-column>
      <af-table-column label="操作" width="240px">
        <template slot-scope="scope">
          <!-- <el-button size="mini" plain @click="carEdit(scope.$index, scope.row)"
                     v-if="checkPermission(['bee:res:car:updateCar'])">编辑
          </el-button> -->
          <el-button size="mini" plain type="danger" @click="carDelete(scope.$index, scope.row)"
                     v-if="checkPermission(['bee:res:car:deleteCar'])">删除
          </el-button>
        </template>
      </af-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="changePage"></Pagination>
<!--  </el-tab-pane>-->
    <AddPage
      :form-visible="addFormVisible"
      @closeDialog="closeDialog"
      @afterAdd="afterAdd"
    ></AddPage>
    <EditPage
      :form-visible="editFormVisible"
      :selectRowData="selectRowData"
      @closeDialog="closeDialog"
      @afterEdit="afterEdit"
    ></EditPage>
  </div>
</template>

<script>
    import Pagination from "../../../../../components/Pagination";
    import carApi from "../../../api/carApi";
    import AddPage from '@/module/resourceCenter/page/car/carList/add.vue';
    import EditPage from '@/module/resourceCenter/page/car/carList/edit.vue';
    import commonApi from "../../../api/commonApi";
    import {validateInput} from '../../../../../common/validator';
    import {validatePhone,validateCarNum} from '../../../../../common/validator';

    export default {
        name: "list",
        data() {
            return {
                searchFormRules: {
                    license: [
                        {validator: function (rule, value, callback) {
                                validateCarNum(rule, value, callback)
                            }, trigger: 'blur'}],
                    phone: [
                        {validator: function (rule, value, callback) {
                                validatePhone(rule, value, callback)
                            }, trigger: 'blur'}],
                    model: [
                        {validator: function (rule, value, callback) {
                                validateInput(rule, value, callback,0,7,true,true,true,false,false,true,false)
                            }, trigger: 'blur'}],
                },
                views: {},
                enumData: [{
                    carTypeData: ''
                }],
                inputVisible: false,
                inputValue: '',
                // restaurants: [],
                tableData: [{}],
                modelTableData: [{}],
                brandTableData: [{}],
                carSearchForm: {},
                modelSearchForm: {},
                brandSearchForm: {},
                listForSelectQuery: {},
                operatorForSelect: [],
                listForSelect: {},
                getCarsLoading: false,
                getBrandLoading: false,
                getModelsLoading: false,
                addForm: {},
                editForm: {},
                carsLoading: false,
                addModelForm: {},
                addBrandForm: {},
                editTypeForm: {},
                addSubmitLoading: false,
                editSubmitLoading: false,
                carModelLoading: false,
                addModelSubmitLoading: false,
                addBrandSubmitLoading: false,
                carBrandLoading: false,
                innerForm: {},
                searchTabsAddForm: {},
                addFormVisible: false,
                editFormVisible: false, // 外部对话框
                addModelFormVisible: false,
                addBrandFormVisible: false,
                viewVisible: false, // 视图
                multipleSelection: [],
                activeName: 'carList',
                innerFormName: 'coordinate',
                viewName: 'detailForm',
                showFilters: true,
                input: '',
                val_time: '', // 创建时间
                formLabelWidth: '150px',
                // 分页参数
                pageparm: {
                    t: {},
                    currentPage: 1,
                    pageSize: 10,
                    total: 0
                },
                activeNames: ['basicInformation', 'addressInformation'],
                activeName: 'carList',
                selectRowData: {}
            }
        },
        methods: {
            // 根据运营商id匹配名字
            formatOperator: function (row, column) {
              let obj = this.operatorForSelect.find((item) => {
                return item.id === row.operatorId
              });
              if (obj != null && obj !== undefined) {
                return obj.name
              } else {
                return row.operatorId
              }
            },
            carTableClick(tab, event) {
                console.log(tab, event)
            },
            // 新增
            carAdd() {
                this.$nextTick(() => {
                    this.addFormVisible = true;
                    this.loadSelectItem();
                    this.addForm = Object.assign({})
                })
                console.log(Object.assign({}))
            },
            // 编辑
            carEdit(index, row) {
                this.editFormVisible = true;
                this.loadSelectItem();
                // this.editForm = Object.assign({}, row)
                // this.editForm.operatorId = this.editForm.operatorId
                // this.editForm.license = this.editForm.license
                // this.editForm.carTypeId = this.editForm.carTypeId
                // this.editForm.vin = this.editForm.vin
                // this.editForm.etc = this.editForm.etc
                // this.editForm.phone = this.editForm.phone
                if (row !== undefined) {
                    this.selectRowData = Object.assign({}, row)
                    this.editFormVisible = true
                }
            },
            // 删除
            carDelete(index, row) {
                this.$confirm('确定要删除：' + row.license + '吗?', '信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.carsLoading = true
                        let param = {id: row.id}
                        carApi.deleteCar(param).then((res) => {
                            if (res.code === 0) {
                                this.$message({
                                    message: res.message,
                                    type: 'success'
                                })
                                this.submitCarSearchForm()
                            } else {
                                this.$message.error(res.message)
                            }
                            this.carsLoading = false
                        })
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除！'
                        })
                    })
            },
            resetSearchForm() {
                this.carSearchForm = {}
                this.submitCarSearchForm()
            },

            submitCarSearchForm() {
                this.$refs.carSearchForm.validate((valid) => {
                    if (!valid) {
                        return;
                    }
                    this.getCarsLoading = true
                    this.carsLoading = true
                    this.pageparm.t = this.carSearchForm
                    let param = Object.assign({}, this.pageparm)
                    carApi.getCars(param).then((res) => {
                        if (res.code === 0) {
                            this.pageparm.total = res.data.total
                            this.tableData = res.data.records
                            // this.$message({
                            //     message: res.message,
                            //     type: 'success'
                            // })
                        } else {
                            this.$message.error(res.message)
                        }
                        this.getCarsLoading = false
                        this.carsLoading = false
                    })
                })
            },

            //查询
            search()
            {
                this.pageparm.currentPage = 1
                this.submitCarSearchForm()

            },
            // 日期格式化
            dateFormatter(row, column) {
                let datetime = row.createTime+"";
                return datetime.substring(0,10)
            },
// 删除
            carDelete(index, row) {
                this.$confirm('确定要删除：' + row.license + '吗?', '信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.carsLoading = true
                        let param = {id: row.id}
                        carApi.deleteCar(param).then((res) => {
                            if (res.code === 0) {
                                this.$message({
                                    message: res.message,
                                    type: 'success'
                                })
                                this.submitCarSearchForm()
                            } else {
                                this.$message.error(res.message)
                            }
                            this.carsLoading = false
                        })
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除！'
                        })
                    })
            },
            // 添加成功后操作
            afterAdd() {
                this.addFormVisible = false
                this.submitCarSearchForm()
            },
            // 编辑成功后操作
            afterEdit() {
                this.editFormVisible = false
                this.submitCarSearchForm()
            },
            // 关闭弹框
            closeDialog(type) {
                console.log('type:' + type)
                if (type === 'add' || type === 'update') {
                    this.addFormVisible  = false
                    this.editFormVisible  = false
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val
            },


            changePage() {
                this.submitCarSearchForm()
            },

            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
                }
            },
            handleSelect(item) {
                console.log(item)
            },
          // 加载下拉框
          loadSelectItem() {
            let param = Object.assign({}, this.pageparm);
            // brand下拉框
            // commonApi.listForSelectQuery(param).then((res) => {

            //   if (res.code === 0) {
            //     this.listForSelectQuery = res.data.records
            //   }
            // })
            // 运营商下拉框
            commonApi.operatorSelectionList().then((res) => {
              if (res.code === 0) {
                this.operatorForSelect = res.data
              }

            })
            // model下拉框
            // commonApi.listForSelect(param).then((res) => {

            //   if (res.code === 0) {
            //     this.listForSelect = res.data.records
            //   }
            //   console.log(res)
            // })
          },
        },
        components: {
            Pagination,
            AddPage,
            EditPage
        },
        created: function () {
          this.loadSelectItem();
        },
        mounted: function () {
            this.submitCarSearchForm()

        }
    }
</script>


<style>
    </style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/car/carList/list.vue